import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class StatsServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getListExtend(params) {
    return this.http.get('/stats', { params });
  }

  export(params) {
    return this.http.post('/stats/export/csv', params);
  }
}

export const StatsService = new StatsServiceClass({
  api_version: 2,
  resource: 'informer'
});
